import { matchPath } from 'react-router';

import { INTERVENTION_MODE } from 'constants/InterventionConstants';
import { ALL_STATS_PATHS_BY_MODE } from 'constants/StatisticsConstants';
import { STATISTICS_LOCATION_CHANGE } from 'modules/statistics/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/statistics/types').StatisticModeReducer} */
const initialState = INTERVENTION_MODE.TECHNICIAN;

/**
 * @param {import('modules/statistics/types').StatisticModeReducer} state
 * @param {import('modules/global/generic.types').LocationChangeAction} param1
 * @return {import('modules/statistics/types').StatisticModeReducer}
 */
const onLocationChange = (state, { payload }) => {
  const pathByMode = Object.entries(ALL_STATS_PATHS_BY_MODE).find(([, paths]) =>
    paths.find(path => matchPath(path, payload.location.pathname)));
  return pathByMode?.[0] ?? state;
};

export default createReducer(initialState, {
  [STATISTICS_LOCATION_CHANGE]: onLocationChange,
});
